<template>
    <div>
        <div class="animated fadeIn" v-if="parameters.length">
            <b-row class="my-3">
                <b-col>
                    <h4 class="text-center text-primary">
                        <i class="fa fa-ticket text-primary mr-2"></i>
                        Parámetros Generales
                    </h4>
                </b-col>
            </b-row>

            <b-row class="pb-2">
                <b-card class="w-100">

                    <b-list-group>
                        <b-list-group-item
                            href="#"
                            class="d-flex justify-content-between align-items-center"
                            v-for="parameter in parameters"
                            v-if="parameter.type === 'GENERAL' || !parameter.type"
                            :key="parameter.uuid"
                            :active="parameterSelected.uuid===parameter.uuid"
                            @click="selectParameter(parameter)">
                            <div>
                                <p class="mb-1">{{ parameter.description }}</p>
                            </div>
                            <div>
                                <template v-if="parameterSelected.uuid===parameter.uuid">
                                    <b-input-group>
                                        <template v-if="isLimitedParameter(parameter.code)">
                                            <b-form-select v-model="value" :options="getParameterValues(parameter.code)"/>
                                        </template>
                                        <template v-else>
                                            <b-form-input v-model="value"/>
                                        </template>

                                        <b-input-group-append>
                                            <b-button
                                                variant="light"
                                                @click.prevent.stop="updateParameter"
                                                v-if="mixinCheckPermission('PARAMETER_EDIT')">
                                                <i class="fa fa-save"></i>
                                            </b-button>
                                            <b-button variant="light" @click.prevent.stop="clearParameterSelected">
                                                <i class="fa fa-times"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </template>

                                <template v-else-if="isLimitedParameter(parameter.code)">
                                    {{ getParameterValues(parameter.code)
                                    .find((param)=>(param.value===parameter.value))
                                    .text }}
                                </template>

                                <template v-else>
                                    {{ parameter.value }}
                                </template>
                                <span style="margin-left: 20px" v-if="parameterSelected.uuid!==parameter.uuid">
                                    {{ parameter.unit }}
                                </span>
                            </div>
                        </b-list-group-item>
                    </b-list-group>

                </b-card>
            </b-row>
        </div>
        <div class="animated fadeIn" v-if="parameters.length">
            <b-row class="my-3">
                <b-col>
                    <h4 class="text-center text-primary">
                        <i class="fa fa-ticket text-primary mr-2"></i>
                        Parámetros de Notificaciones
                    </h4>
                </b-col>
            </b-row>
            <b-row class="pb-2">
                <b-card class="w-100">
                    <b-list-group>
                        <b-list-group-item
                                href="#"
                                class="d-flex justify-content-between align-items-center"
                                v-for="parameter in parameters"
                                v-if="parameter.type === 'NOTIFICATION'"
                                :key="parameter.uuid"
                                :active="parameterSelected.uuid===parameter.uuid"
                                @click="selectParameter(parameter)">
                            <div>
                                <p class="mb-1">{{ parameter.description }}</p>
                            </div>

                            <div>
                                <template v-if="parameterSelected.uuid===parameter.uuid">
                                    <b-input-group>
                                        <template v-if="isLimitedParameter(parameter.code)">
                                            <b-form-select v-model="value" :options="getParameterValues(parameter.code)"/>
                                        </template>
                                        <template v-else>
                                            <b-form-input v-model="value"/>
                                        </template>

                                        <b-input-group-append>
                                            <b-button
                                                    variant="light"
                                                    @click.prevent.stop="updateParameter"
                                                    v-if="mixinCheckPermission('PARAMETER_EDIT')">
                                                <i class="fa fa-save"></i>
                                            </b-button>
                                            <b-button variant="light" @click.prevent.stop="clearParameterSelected">
                                                <i class="fa fa-times"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </template>

                                <template v-else-if="isLimitedParameter(parameter.code)">
                                    {{ getParameterValues(parameter.code)
                                    .find((param)=>(param.value===parameter.value))
                                    .text }}
                                </template>

                                <template v-else>
                                    {{ parameter.value }}
                                </template>
                                <span style="margin-left: 20px" v-if="parameterSelected.uuid!==parameter.uuid">
                                    {{ parameter.unit }}
                                </span>
                            </div>
                        </b-list-group-item>
                    </b-list-group>
                </b-card>
            </b-row>
        </div>
    </div>
</template>

<script>
    import {updateParameter, getParameters} from '@/api/parameter-api';
    import {isLimitedParameter, getParameterValues} from '@/helpers/parameter-helper';
    import Multiselect from 'vue-multiselect';

    export default {
        name: "general-parameters",
        components: {
            Multiselect
        },
        data: function () {
            return {
                topmenu: [
                    {
                        name: 'Inicio',
                        path: '/admin/dashboard',
                        brand: 'fa fa-home'
                    }
                ],
                parameters: [],
                parameterSelected: {
                    uuid: null,
                    code: null,
                    value: null,
                    description: null
                },
                value: null
            }
        },
        mounted() {
            this.$eventHub.$emit('captureMenu', this.topmenu);
            this.getParameters();
        },
        methods: {
            async getParameters() {
                this.$_loadingMixin_showLoading();
                await getParameters()
                    .then((parameters) => {
                        this.parameters = parameters;
                    });
                this.$_loadingMixin_hideLoading();
            },
            async updateParameter() {
                this.$_loadingMixin_showLoading();
                await updateParameter(this.parameterSelected.code, this.value)
                    .then((response) => {
                        this.parameterSelected.value = this.value;
                        this.$_notificationMixin_success(
                            'Operación completada',
                            'Registro actualizado con éxito'
                        );
                    })
                    .catch(() => {
                        this.$_notificationMixin_error(
                            'Error en la operación',
                            'No se ha podido actualizar el registro'
                        );
                    });
                this.$_loadingMixin_hideLoading();
            },
            selectParameter(parameter) {
                this.parameterSelected = parameter;
                this.value = parameter.value;
            },
            clearParameterSelected() {
                this.parameterSelected = Object.assign({}, {
                    uuid: null,
                    code: null,
                    value: null,
                    description: null
                });
                this.value = null;
            },
            isLimitedParameter(parameterCode) {
                return isLimitedParameter(parameterCode)
            },
            getParameterValues(parameterCode) {
                return getParameterValues(parameterCode)
            }
        }
    }
</script>

<style scoped>

</style>
